import { tierLimitOf, tierLimitText } from '@bluebear/chat-ui/bluebear';

export function normalizeRecoveryActions(value) {
  return Array.isArray(value) ? value.filter((item) => typeof item === 'string') : [];
}

export function modelAccessRecoveryFromError(err) {
  const data = err?.response?.data || {};
  const rawActions = data.recovery_actions || data.recoveryActions;
  const recoveryActions = normalizeRecoveryActions(rawActions);
  const code = data.code || data.error || err?.code;
  const status = err?.response?.status;
  const isModelAccessError =
    status === 402 ||
    code === 'INSUFFICIENT_CREDITS' ||
    code === 'credits_exhausted' ||
    code === 'KEY_NOT_FOUND' ||
    code === 'NO_KEY_AVAILABLE';

  if (!isModelAccessError && recoveryActions.length === 0) return null;

  const canAddApiKey = recoveryActions.includes('add_api_key');
  const canBuyCredits = recoveryActions.includes('buy_credits');

  return {
    type: canAddApiKey ? 'credits_or_api_key' : 'credits',
    // A plan's limit in the reader's own time (the gateway's words are UTC).
    message: tierLimitOf(data) ? tierLimitText(tierLimitOf(data)) : data.message || 'Add an API key for this model or buy credits to continue.',
    recoveryActions,
    canAddApiKey,
    canBuyCredits,
  };
}

export function modelAccessRecoveryMessage(err, fallback = 'Something went wrong') {
  const recovery = modelAccessRecoveryFromError(err);
  if (recovery) return recovery.message;
  return err?.response?.data?.error || err?.message || fallback;
}

/**
 * The credits line after a refused (402) send or warm. A plan's limit (`details.tier`) refused it: the person
 * keeps their balance (null: the refusal sent none, keep the one shown) and the line says the limit in their own
 * time. Otherwise the balance ran out.
 */
export function creditStateFromRefusal(data) {
  const tier = tierLimitOf(data);
  if (tier) {
    const balance = data?.balance == null ? NaN : Number(data.balance);
    return { balance: Number.isFinite(balance) ? balance : null, message: tierLimitText(tier), tier: true };
  }
  return { balance: 0, message: null, tier: false };
}

/** The credits line from /credits/availability: nothing when allowed, a plan's limit in the reader's time, else its words. */
export function availabilityMessage(data) {
  if (!data || data.allowed) return null;
  const tier = tierLimitOf(data);
  return tier ? tierLimitText(tier) : data.message ?? null;
}
